import { SelectProps } from "@chakra-ui/react";
import { useAdmins } from "../../hooks/user.hooks";
import Select from "./Select";
import { User } from "../../types/user.types";

function SelectAdmin({
	user,
	setUser,
	...props
}: SelectProps & { user?: User; setUser?: (user?: User) => void }) {
	const { data: admins } = useAdmins();

	return (
		<Select
			{...props}
			value={user ? user.id : undefined}
			onChange={(evt) => {
				if (setUser) {
					const user = admins?.find(
						(user) => user.id.toString() === evt.target.value,
					);
					setUser(user);
				}
			}}
		>
			{admins &&
				admins.map((admin) => {
					return (
						<option value={admin.id}>
							{admin.firstName}&nbsp;{admin.lastName}
						</option>
					);
				})}
		</Select>
	);
}

export default SelectAdmin;
